import { getEnumAll } from '@/api/enum/enumApi';

export default {
	namespaced: true, // 很重要！

	state: {
		loaded: false,
		menuRaw: {}, // 原始菜单数据
		menuMap: {}, // Map 结构，用于快速获取 label
	},

	mutations: {
		SET_MENU(state, data) {
			state.menuRaw = data;
			const temp = {};
			Object.keys(data).forEach(key => {
				const map = new Map();
				data[key].forEach(item => {
					map.set(String(item.value), item.name);
				});
				temp[key] = map;
			});
			state.menuMap = temp;
			state.loaded = true;
		},
	},

	actions: {
		async initMenu({ state, commit }) {
			if (state.loaded) return;
			const res = await getEnumAll();
			commit('SET_MENU', res || {});
		},
	},

	getters: {
		// 获取列表
		getMenuList: state => type => {
			return state.menuRaw[type] || [];
		},

		// 获取 label
		getMenuLabel: state => (type, value) => {
			const map = state.menuMap[type];
			return map ? map.get(String(value)) : '';
		},
	},
};
